import { apiCMSWithToken } from './axios'

export const url = {
  pakageCommunity: `/pakage-community`
}

export async function getPakageCommunity(p = {}) {
  try {
    const params = new URLSearchParams({ ...p })
    const response = await apiCMSWithToken.get(
      `${url.pakageCommunity}?${params.toString()}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function pakageCommunityAdd(body) {
  const response = await apiCMSWithToken.post(`${url.pakageCommunity}`, body)
  return response
}

export async function pakageCommunityUpdate(body, id) {
  const response = await apiCMSWithToken.put(
    `${url.pakageCommunity}/${id}`,
    body
  )
  return response
}

export async function pakageCommunityDetail(id) {
  try {
    const response = await apiCMSWithToken.get(`${url.pakageCommunity}/${id}`)

    return response
  } catch (error) {
    console.error('Error in issueSearch:', error)
    throw error
  }
}

export async function deleteItemPakge(body) {
  try {
    const response = await apiCMSWithToken.delete(`${url.pakageCommunity}`, {
      data: body
    })
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

// export async function notificationStatus(status, id) {
//   const body = {
//     status: status
//   }
//   try {
//     const response = await apiCMSWithToken.put(`${F18_SERVICES.notification}/status/${id}`, body)

//     return response
//   } catch (error) {
//     console.error('Error in issueSearch:', error)
//     throw error
//   }

// }

export async function getPakageCommunityHistory(p = {}) {
  try {
    const params = new URLSearchParams({ ...p })
    const response = await apiCMSWithToken.get(
      `${url.pakageCommunity}/history?${params.toString()}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function pakageCommunityExtension(body) {
  const response = await apiCMSWithToken.post(`${url.pakageCommunity}/community_package_extension`, body)
  return response
}


export default {
  getPakageCommunity,
  pakageCommunityAdd,
  pakageCommunityUpdate,
  pakageCommunityDetail,
  deleteItemPakge,
  getPakageCommunityHistory,
  pakageCommunityExtension
}
